import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { LoggerService } from '../shared/logger.service';
import { AuthTokenService } from '../auth/auth-token.service';
import { Subscription } from 'rxjs';
import { User } from '../auth/me.lib';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule
  ],
  providers: [
    HttpClientModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {

  isLoggedIn: boolean = this.authTokenService.loggedIn;
  me: User | null = null;

  private _subs: Subscription[] = [];

  constructor(
    private router: Router,
    public faIcons: FaIconLibrary,
    private logger: LoggerService,
    private authTokenService: AuthTokenService
  ) {
    faIcons.addIcons(...all);
  }

  ngOnInit(): void {
    this.logger.debug('Home INIT');
    this._subs.push(this.authTokenService.user$.subscribe(u => {
      this.me = u;
    }));
    this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    }))
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }


}
